import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../../auth/auth-provider/auth-provider";
import GetProfileById from "../../api-layer/profile-api/GetProfileById";

const ProfileDetailContext = createContext();

const ProfileDetailProvider = ({children}) => {
    const auth = useAuth();
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        getProfile();
    }, [
        auth?.user?.profileId,
    ])

    const getProfile = () => {
        GetProfileById(auth?.user?.profileId).then(
            response => {
                setProfile(response.data);
            }
        ).catch(
            error => {
            }
        );
    }

    return (
        <ProfileDetailContext.Provider
            value={{
                profile,
                setProfile,
                getProfile,
            }}
        >
            {children}
        </ProfileDetailContext.Provider>
    );
}

export default ProfileDetailProvider;

export const useProfileDetail = () => {
    const context = useContext(ProfileDetailContext);
    return context;
}